import { RecommendationsState } from '../../../models';
import { isArrayEmptyOrNull } from '../../../utils';
import { RECOMMENDATIONS_GETTERS_KEYS } from '../recommendations.const';
import { RecommendationsGetter } from '../recommendations.interfaces';

export class InfiniteScrollEnabledGetter implements RecommendationsGetter {
  getters = {
    [RECOMMENDATIONS_GETTERS_KEYS.infiniteScrollEnabled]: (state: RecommendationsState): boolean =>
      !state.loading
      && state.infiniteScrollEnabled
      && !isArrayEmptyOrNull(state.recommendations)
      && state.hasMore
  };
}
